import React from "react";
import { observer, inject } from "mobx-react";
import "./MedDetail.scss";
import Widget from "../Widget";
import { formatDateTime } from "../../shared/dateTimeUtils";

class MedDetail extends Widget {
  constructor(props) {
    super(props);
    if (!this.props.location.state) {
      props.history.goBack();
    } else {
      this.med = this.props.location.state;
    }
  }

  render() {
    const med = this.med;
    if (!med) return null;
    return (
      <div className="med-detail widget">
        <div className="med-detail-content">
          <h1>{med.name}</h1>
          <h2>Details</h2>
          <table className="row">
            <tbody>
              <tr>
                <td className="label">Ordered Item</td>
                <td className="value">{med.orderedItem}</td>
              </tr>
              <tr>
                <td className="label">Details</td>
                <td className="value">{med.clinicalDisplay}</td>
              </tr>
              <tr>
                <td className="label">Ordered Dose</td>
                <td className="value">{med.orderedDose || null}</td>
              </tr>
              <tr>
                <td className="label">Comment</td>
                <td className="value">{med.comments}</td>
              </tr>
              <tr>
                <td className="label">Therapeutic Class</td>
                <td className="value">
                  {med.therapeuticCategories.join(", ") || null}
                </td>
              </tr>
              <tr>
                <td className="label">Route</td>
                <td className="value">{med.route}</td>
              </tr>
              <tr>
                <td className="label">Frequency</td>
                <td className="value">{med.frequency}</td>
              </tr>
              <tr>
                <td className="label">Duration</td>
                <td className="value">{med.duration}</td>
              </tr>
              <tr>
                <td className="label">Start</td>
                <td className="value">
                  {formatDateTime(med.startDateTime, "-")}
                </td>
              </tr>
              <tr>
                <td className="label">Stop</td>
                <td className="value">
                  {formatDateTime(med.startDateTime, "-")}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default inject("store")(observer(MedDetail));
